module.exports = __webpack_public_path__ + "static/media/1.6_manual.aeb63720.png";